import type { Quote } from "./types";
import { createQuoteStory } from "./types";

export const ilmuMuslim2699: Quote = {
  id: "ilmu-muslim-2699",
  name: "Menempuh Jalan Menuntut Ilmu",
  emoji: "🛤️",
  category: "Ilmu & Hikmah",
  description:
    "Rasulullah ﷺ bersabda: **\"Barangsiapa menempuh jalan untuk menuntut ilmu, Allah mudahkan baginya jalan menuju surga.\"**",
  detail:
    "Hadits ini menjanjikan bahwa setiap usaha menuntut ilmu — sekecil apapun — adalah jalan yang Allah mudahkan menuju surga. **\"Jalan\" di sini mencakup segala bentuk upaya**: membaca, bertanya, menghadiri majelis ilmu, bahkan membuka tutorial di tengah malam.",
  tldr: "Setiap langkah belajar adalah jalan yang Allah mudahkan menuju surga.",
  story: createQuoteStory("Menempuh Jalan Menuntut Ilmu", "🛤️", [
    { hook: {
      title: "Belajar terasa berat?",
      body: "Kamu berjuang memahami sesuatu yang baru, merasa lambat, merasa tertinggal. Tapi Rasulullah ﷺ bilang justru **perjuanganmu itu yang berharga**...",
    } },
    { source: {
      arabic: "مَنْ سَلَكَ طَرِيقًا يَلْتَمِسُ فِيهِ عِلْمًا سَهَّلَ اللَّهُ لَهُ بِهِ طَرِيقًا إِلَى الْجَنَّةِ",
      body: "Barangsiapa **menempuh jalan** untuk menuntut ilmu, Allah **mudahkan baginya jalan menuju surga.**",
      title: "HR. Muslim no. 2699",
    } },
    { reveal: {
      body: "Perjuangan belajar itu bukan hambatan — **itu jalannya.** Setiap kali kamu berusaha memahami sesuatu, kamu sudah ada di jalan yang Allah janjikan kemudahan di ujungnya.",
    } },
    { insight: {
      title: "\"Jalan\" itu luas maknanya",
      body: "Bukan cuma duduk di kelas. **Membaca buku, bertanya kepada guru, menghadiri kajian, bahkan membuka tutorial di tengah malam** — semua itu termasuk \"menempuh jalan\" menuntut ilmu. Yang penting ada niat belajar dan usaha nyata. Allah gak minta kamu langsung pintar — **Allah minta kamu terus melangkah.**",
    } },
    { engagement: {
      title: "Apapun yang sedang kamu pelajari sekarang...",
      body: "Kamu sudah di jalannya. **Terus melangkah.** Share hadits ini ke teman yang lagi berjuang belajar. 📚",
    } },
  ]),
  related: ["ilmu-mujadilah-11"],
};
